import * as Preact from "preact"

import elements from "@frog/source/data/elements.js"

import "./ItemBreakdown.less"

export default function ItemBreakdown({item, unit, stage}) {
    if(item == undefined) return

    let element = elements[item.element]

    // TODO: move this to a centralized function, called both in DiceFace and Dice and other places.
    let power = ((item.power || 0) + (unit.power || 0))
    if(item.powerboost instanceof Function) {
        power += item.powerboost({"stage": stage, "unit": unit, "item": item})
    }

    return (
        <div class="ItemBreakdown">
            <div class="Contents">
                <div class="Icon" style={{"background-image": item.icon && "url(" + item.icon + ")"}}/>
                <div class="Summary">
                    <div class="Title">{item.title} {power / 10}</div>
                    <div class="CoolDescription">
                        {item.description instanceof Function ? item.description({item, unit, stage}) : item.description}
                    </div>
                </div>
                <div class="KeywordDefinition" hasKeyword={!!item.keyword}>
                    <div class="Text"><b>{item.keyword?.name}</b>: {item.keyword?.description()}</div>
                </div>
                <div class="Flavor" hasFlavor={!!item.flavor}>
                    <div class="Text">{item.flavor}</div>
                </div>
                <div class="Elements" hasElement={!!item.element} element={item.element}>
                    <div class="Element"><span class="Keyword" element={element.key}>{element.name}</span> Damage</div>
                    <div class="Effectiveness">
                        Strong against <span class="Keyword" element={element.strengths[0]}>{elements[element.strengths[0]].name}</span> (2x damage)
                    </div>
                    <div class="Ineffectiveness">
                        Weak against <span class="Keyword" element={element.weaknesses[0]}>{elements[element.weaknesses[0]].name}</span> (½x damage)
                    </div>
                </div>
            </div>
        </div>
    )
}
